export const checkout_entrance_mapping = {
    email: 'username',
    cart: 'guestCart',
    id: 'cartId',
};
